module.exports = __webpack_public_path__ + "static/media/explore-footer.cf5d2df9.png";